import { FieldProps } from 'formik';
import { CollectionAutocomplete } from '../collection-autocomplete';
import { useLeadConnections } from 'features/lead/lead-companies/lib';

type Company = {
  id: number;
  name: string;
};

export const LeadCompanyPickerField = (
  props: { leadId: number } & FieldProps<number | null>
) => {
  const { leadId, field, form, meta, ...rest } = props;
  const companies = useLeadConnections(leadId);
  const formattedCompanies = companies.companies?.map((company: Company) => ({
    id: company.id,
    label: company.name
  })) || [];
  
  return (
    <CollectionAutocomplete
      field={field}
      form={form}
      isLoading={companies.isLoading}
      items={formattedCompanies}
      clearable={true}
      label={'Компания'}
      meta={meta}
      {...rest} />
  );
};
